import { render } from "./ModalEditValorModulo.vue?vue&type=template&id=ca27a2d4"
import script from "./ModalEditValorModulo.vue?vue&type=script&lang=js"
export * from "./ModalEditValorModulo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__